import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import {
  BORDER_RADIUS,
  BREAKPOINTS,
  MOBILE_BREAKPOINT,
} from '@src/styles/config';
import { Typography } from '@mui/material';

export const StyledVoiceItemCardNew = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 16px;
  height: 116px;
  align-items: center;
  border-radius: ${BORDER_RADIUS};
  background: ${COLOR.charcoal};
  cursor: pointer;
  position: relative;

  .badge-avatar {
    align-self: center;
  }

  .verified-icon {
    width: 24px;
    height: 24px;
  }

  .voice-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
    padding: 16px 0px;

    .name-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      position: relative;
      justify-content: space-between;

      .name-info-left {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px !important;
        flex: 1;
        min-width: 0;
        max-width: 360px;
      }

      @media only screen and (max-width: ${BREAKPOINTS.CMLG}px) {
        .name-info-left {
          max-width: 330px !important;
        }
      }

      .name {
        color: ${COLOR.darkBlue};
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .province-text {
        color: ${COLOR.darkV2[64]};
        white-space: nowrap;
      }
    }

    .category-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;

      > * {
        color: ${COLOR.darkV2[64]};
      }

      .category-dot {
        font-size: 14px;
        line-height: 20px;
      }
    }

    .status-action-row {
      display: flex;
      flex-direction: row;
      gap: 4px;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding-top: 4px;
    }

    .status {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .action-buttons {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;
    }
  }

  .view-reason {
    .view-reason-text {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: ${COLOR.bluev2[100]};
      text-decoration: underline;
    }
  }

  .more-horiz-btn {
    padding: 4px;
    min-width: 10px;
    min-height: 10px;
    width: 32px;
    height: 32px;
    color: ${COLOR.darkBlue};
    border: 1px solid ${COLOR.darkV2[32]};
    border-radius: 8px;
    background-color: ${COLOR.white};

    &:hover {
      background: ${COLOR.darkV2[8]};
    }
  }

  .redirect-btn {
    width: 32px;
    height: 32px;
    color: ${COLOR.indigo[64]};
  }

  .icon-size-6 {
    font-size: 6px !important;
    color: ${COLOR.darkV2[64]};
  }

  .icon-size-20 {
    font-size: 20px !important;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .voice-info {
      .name-info {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 200px;
      }
    }
  }
`;

export const StyledActionMenuPopover = styled('div')`
  .menu-container {
    padding: 8px;
    min-width: 200px;
  }

  .menu-item {
    border-radius: 8px;
    padding: 10px 12px;
    gap: 8px;

    &:hover {
      background: ${COLOR.darkV2[8]};
    }
  }
`;

export const StyledChip = styled(Typography)`
  background-color: ${({ color }) => TRANSPARENT_COLOR[color]};
  color: ${({ color }) => COLOR[color]};
  text-align: center;
  align-items: center;
  padding: 3px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  width: fit-content;
`;
